// Which clips post as a set of slides, and which files make up that set.

const IMAGE = /\.(png|jpe?g|webp)$/i;
const VIDEO = /\.(mp4|webm|mov)$/i;

// Built in, so a carousel is never offered the single-video send while the
// registry is still loading; any registry style of kind "carousel" counts too.
const CAROUSEL_STYLES = new Set(['genericCarousel', 'technologyCarousel']);

export const isCarouselStyle = (styleId: string, registryKind?: string): boolean =>
  CAROUSEL_STYLES.has(styleId) || registryKind === 'carousel';

const isPlaceholder = (url: string) => url.includes('_waiting') || url.includes('_failed');

/**
 * The files a carousel posts, in slide order. A rendered video slide arrives as
 * its poster still followed by its clip (Remotion renders slide_NN.png, then
 * slide_NN.mp4), so the clip takes the poster's place.
 */
export const carouselSlidePaths = (fileUrls: string[]): string[] => {
  const slides: string[] = [];
  fileUrls.forEach((url) => {
    if (isPlaceholder(url)) return;
    if (VIDEO.test(url)) {
      const previous = slides[slides.length - 1];
      if (previous !== undefined && IMAGE.test(previous)) slides.pop();
      slides.push(url);
    } else if (IMAGE.test(url)) {
      slides.push(url);
    }
  });
  return slides;
};
